<template>
  <div class="flex justify-center text-1.5rem text-black">Not Found</div>
</template>

<style scoped></style>
